import { Box, Container, Paper } from "@mui/material";
import React from "react";

export default function gene20CoverContainer({ children }) {
  return (
    <Container
      maxWidth="lg"
      sx={{
        overflowX: "hidden",
        display: "flex",
        // marginTop: "10vh",
        padding: "0",
        minHeight: "80vh",
        height: "100%",
        width:"100%"
      }}
    >
      {children}
    </Container>
  );
}
